module.exports = __webpack_public_path__ + "static/img/22ef6a322c6c59c06bd2fa4edab71dec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pro_banner.jpg
// module id = KjJS
// module chunks = 1